import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const { primary } = theme.palette;

  return {
    root: {
      position: "relative"
    },
    rootSticky: {
      borderRadius: 5,
      boxShadow: "0px 1px 7px 0px rgba(0, 0, 0, 0.1)"
    },
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-end",
      marginBottom: 6,
      borderRadius: "5px 5px 0 0",
      padding: "9px 8px 4px 16px"
    },
    headerSticky: {
      background: "#fff",
      marginBottom: 0,
      borderBottom: `1px solid ${theme.palette.text.hint}`
    },
    allComments: {
      marginBottom: 6
    },
    allCommentsText: {
      fontSize: 16,
      color: "#595a5a",
      marginRight: 8
    },
    allCommentsTextSticky: {
      fontSize: 14,
      color: primary.main
    },
    markAllComments: {
      fontSize: 14,
      color: "#dadada",
      textTransform: "capitalize",
      padding: "2px 8px"
    },
    markAllCommentsActive: {
      color: primary.dark,
      cursor: "pointer"
    },
    badge: {
      minWidth: 16,
      height: 16,
      position: "relative",
      marginTop: -2,
      transform: "inherit",
      transition: "none"
    },
    list: {
      background: "#fff",
      borderRadius: 5,
      boxShadow: "0px 1px 7px 0px rgba(0, 0, 0, 0.1)"
    },
    comment: {
      padding: "14px 16px"
    },
    listSticky: {
      maxHeight: 428,
      overflow: "auto",
      borderRadius: "0 0 5px 5px",
      boxShadow: "none"
    },
    item: {
      padding: "10px 16px 12px",
      background: "rgba(238, 238, 238, 0.25)",
      borderTop: "1px solid #eee",
      "&:nth-child(2n-1)": {
        background: "#fff"
      },
      "&:first-child": {
        borderTop: 0,
        borderRadius: "inherit"
      }
    },
    info: {
      fontSize: 14,
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
      color: primary.main,
      position: "relative",
      marginBottom: 9
    },
    role: {
      marginRight: 7
    },
    roleIcon: {
      fontSize: 11
    },
    status: {
      position: "absolute",
      top: -9,
      right: -15
    },
    statusIcon: {
      fontSize: 13,
      fill: "#dadada"
    },
    statusIconActive: {
      fill: theme.palette.warning.dark
    },
    date: {
      fontSize: 12,
      color: primary.dark,
      marginBottom: 4
    },
    content: {
      color: primary.dark,
      fontSize: 12,
      wordBreak: "break-word"
    },
    contentUnread: {
      color: "rgba(34, 34, 34, 1)"
    },
    empty: {
      fontSize: 18,
      color: primary.dark,
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    oddComment: {
      backgroundColor: "#f6f6f6"
    },
    loaderFetching: {
      position: "absolute",
      backgroundColor: "#fff",
      opacity: 0.5,
      maxHeight: 428
    }
  };
});
